import moment from "moment";

export const CcmodeUserInvitationTableColumns = (inviteLoading, resendInvitation) => [
    {
        Header: "Name",
        accessor: "display_name",
        className: "align-middle",
    },
    {
        Header: "Email",
        accessor: "email",
        className: "align-middle",
    },
    {
        Header: "Expires At",
        accessor: (row) => {
            return <div>{moment(row.expires_at).format("YYYY-MM-DD")}</div>;
        },
        className: "align-middle text-center",
    },
    {
        Header: "Days Left",
        accessor: (row) => {
            return (
                <div className="text-capitalize">
                    {row.days_remaining} days remaining
                </div>
            );
        },
        className: "text-center align-middle",
    },
    {
        Header: "Status",
        accessor: (row) => {
            if (row.invitation_state === "pending")
                return (
                    <div className="label label-outline-success label-pill label-inline bg-success-o-30 px-5">
                        {row.invitation_state}
                    </div>
                );

            if (row.invitation_state === "expired")
                return (
                    <div className="label label-outline-danger label-pill label-inline bg-danger-o-30 px-5">
                        {row.invitation_state}
                    </div>
                );
        },
        className: "text-center align-middle text-capitalize",
    },
    {
        Header: "Action",
        className: "text-center align-middle text-capitalize",
        disableSortBy: true,
        accessor: (row) => {
            
            return <button
                disabled={inviteLoading}
                type="button"
                className="btn btn-primary btn-sm text-capitalize"
                onClick={() => resendInvitation(row.email)}
            >
                Resend Invitation
            </button>
        },
    },
];
